// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_d0-a";
export var fulfillmentFormRail = "_d0-9";
export var headerTitleRow = "_d0-c";
export var orderDetailsWrapper = "_d0-7";
export var orderLinkTrigger = "_d0-2";
export var paymentInformationGrid = "_d0-h";
export var paymentSummaryColumn = "_d0-i";
export var shipmentContainer = "_d0-b";
export var shipmentDetailsMainPane = "_d0-8";
export var shipmentNavigationCard = "_d0-5";
export var shipmentNavigationRail = "_d0-3";
export var shipmentNavigationRailHeader = "_d0-4";
export var shipmentSummaryFact = "_d0-e";
export var shipmentSummaryGrid = "_d0-d";
export var shipmentSummaryMetadataRow = "_d0-f";
export var shipmentSummaryTags = "_d0-g";
export var shipmentWorkspace = "_d0-0";
export var shipmentWorkspaceContent = "_d0-6";
export var shipmentWorkspaceHeader = "_d0-1";